import ReactSelect, { GroupBase, Props as SelectProps } from 'react-select';

const customSelectStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    border: '1px solid #ff9f24',
    borderRadius: '10px',
    boxShadow: 'inset 1px 1px 3px rgba(0, 0, 0, 0.25)',
    fontSize: '14px',
    fontFamily: '"DM Sans", sans-serif',
    fontWeight: '300',
    lineHeight: '20px',
    letterSpacing: '0.02em',
    backgroundColor: '#fff',
    minHeight: '38px',
    height: '38px',
    '&:hover': {
      border: '1px solid #ff9f24',
    },
    '&:focus': {
      border: '1px solid #ff9f24',
      boxShadow: 'inset 1px 1px 3px rgba(0, 0, 0, 0.25)',
    },
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: '#888',
    opacity: 1,
    fontSize: '14px',
    fontFamily: '"DM Sans", sans-serif',
    fontWeight: '300',
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: '#000',
    fontSize: '14px',
    fontFamily: '"DM Sans", sans-serif',
    fontWeight: '300',
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: '#888',
    padding: '0 6px',
    '&:hover': {
      color: '#666',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: '2px 8px',
    height: '36px',
  }),
  input: (provided: any) => ({
    ...provided,
    margin: '0',
    padding: '0',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '10px',
    border: '1px solid #ff9f24',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: '14px',
    fontFamily: '"DM Sans", sans-serif',
    fontWeight: '300',
    backgroundColor: state.isSelected
      ? '#ff9f24'
      : state.isFocused
        ? '#fff3e0'
        : '#fff',
    color: state.isSelected ? '#fff' : '#000',
    '&:hover': {
      backgroundColor: state.isSelected ? '#ff9f24' : '#fff3e0',
    },
  }),
};

const Select = <
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: SelectProps<Option, IsMulti, Group>
) => {
  return <ReactSelect {...props} styles={customSelectStyles} />;
};

export default Select;
